import { useQuery } from '@tanstack/react-query';
import { fetchItemDetail } from '@/api/client';
import type { LanguageCode } from '@/types';

export function useItemDetail(lang: LanguageCode, id: number | null) {
  return useQuery({
    queryKey: ['item', lang, id],
    queryFn: () => fetchItemDetail(lang, id as number),
    enabled: id !== null,
  });
}
